module.exports = __webpack_public_path__ + "media/images/but-click-here-2de8724f.png";